import React from "react";
import { useSelector } from "react-redux";
import { selectParentRegistration } from "../../../redux/slices/parentRegistrationSlice";
import { selectAllClassifications } from "../../../redux/slices/classificationsSlice";
import { selectAllCategories } from "../../../redux/slices/categoriesSlice";
import { selectTeams } from "../../../redux/slices/teamsSlice";
import { updateRegistrationClassification } from "../../../redux/slices/registrationSlice";
import { selectCurrentPage } from "../../../redux/slices/currentPageSlice";
import { setAppShowRemainingForm } from "../../../redux/slices/appSettingsSlice";
import UpdateFCRegistration from "./UpdateFCRegistration";

const ConnectedUpdateFCRegistration = () => {
    const parentRegistration = useSelector(selectParentRegistration);
    // Items from Parent Reg we want to match in this registration
    const { Classification } = parentRegistration;
    const classifications = useSelector(selectAllClassifications);
    const categories = useSelector(selectAllCategories);
    const teams = useSelector(selectTeams);
    const currentPage = useSelector(selectCurrentPage);

    // Double checking Classification from parent registration
    const filteredClassifications = classifications.filter(
        ({ registrantSpotsLeft = -1 }) => {
            const soldOut = registrantSpotsLeft === 0;
            return !soldOut;
        },
    );

    const autoSelectClassification = !!filteredClassifications
        .map((classification) => `${classification.id}`)
        .includes(Classification);

    const updateFCRegistrationProps = {
        autoSelectClassification,
        categories,
        currentPage,
        parentRegistration,
        teams,
        updateRegistrationClassification,
        setAppShowRemainingForm,
    };
    return <UpdateFCRegistration {...updateFCRegistrationProps} />;
};

export default ConnectedUpdateFCRegistration;
